// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","default":"button_default__yEbPi","outline":"button_outline__CvjMk"};